import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PageLoaderEffects } from './page-loader.effects';
import { PageLoaderFacade } from './page-loader.facade';
import { pageLoaderReducer } from './page-loader.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('isPageLoading', pageLoaderReducer),
    EffectsModule.forFeature([
      PageLoaderEffects,
    ]),
  ],
  providers: [
    PageLoaderFacade,
  ],
})
export class PageLoaderModule {}
